import React from 'react';
import { Table } from 'antd';

const LineItemBeaconList = ({ list, columns }) => (
  <Table pagination={false} rowKey="beacon_id" dataSource={list} columns={columns} />
);

LineItemBeaconList.defaultProps = {};

LineItemBeaconList.propTypes = {};

export default LineItemBeaconList;
